/** The officer queue, its lanes and bands, the assignee and the dashboard's queue figures (planning Phase 3 P3-4). */
export default {
  queue: {
    view: { label: 'View', list: 'List', queue: 'Queue' },
    title: 'Work queue',
    subtitle: 'Open submissions ranked by their nearest deadline.',
    asAt: 'Urgency as at {{time}}',
    lanes: {
      label: 'Whose turn',
      authority: 'Our deadlines',
      response: 'Waiting for others',
      lapse: 'Permissions that may lapse',
    },
    bands: {
      label: 'Filter by urgency',
      all: 'All',
      overdue: 'Overdue',
      due_soon: 'Due soon',
      on_track: 'On track',
      applicant_turn: "Applicant's turn",
      uncovered: 'Not covered by the calendar',
      none: 'No deadline',
    },
    mine: 'My cases',
    columns: {
      case: 'Submission',
      stage: 'Step',
      deadline: 'Deadline',
      band: 'Urgency',
      kpktDays: 'KPKT days',
      days: 'Days',
      applicantDays: "Applicant's days",
      assignee: 'Assigned to',
    },
    daysOf: '{{days}} of {{units}}',
    dueOn: 'Due {{date}}',
    uncoveredDue: 'No date until the calendar covers it',
    unassigned: 'Unassigned',
    assignLabel: 'Assign {{caseRef}}',
    assignFailed: 'The assignment was not saved: {{message}}',
    empty: 'No open submission in this queue.',
    emptyMine: 'No open submission in this queue is assigned to you.',
    summary: {
      title: 'Deadlines',
      hint: 'Open submissions by urgency; each figure opens its queue.',
      onTime: 'On time by scale',
      scale: 'Scale',
      clock: 'Deadline',
      met: 'On time',
      missed: 'Late',
      share: 'Share on time',
      noScale: 'No scale',
      none: 'No deadline has been met or missed yet.',
    },
  },
  errors: {
    invalid_assignee: 'That person cannot be assigned: choose an officer who may act on submissions.',
  },
}
